import { autoSubmitOnSelect, initBackLink, initFormFields, } from "../../common/scripts/helpers/form";
import { initRangeSliders } from "../../common/scripts/helpers/form/range-slider";
import { isIE, markIeOnHtmlDataAttribute } from "../../common/scripts/helpers/is-ie";
import { initAddressAutocomplete } from "./steps/address";
import { validateMobile } from "./steps/input/validate-mobile";
import { initIntroStep } from "./steps/intro";
import { initStepResult } from "./steps/result";
import { initStepVerification } from "./steps/verification";
import { initValidateLivingAreaAndOrBuildingVolume } from './steps/input/validate-living-area-and-or-building-volume'
import { initQuickNav, initHide } from "./result"

$("document").ready(function () {
  initBackLink();
  initRangeSliders();
  /**
   * Make SVGs unfocussable
   */
  $("svg").attr("focusable", false);

  /**
   * Add IE class to body if browser is internet explorer
   */
  markIeOnHtmlDataAttribute();

  /**
   * Initialize the step
   */
  // Get the current step
  const step = $("body").attr("data-step");

  // Init the step
  switch (step) {
    case "intro":
      initIntroStep();
      break;
    case "building-usage":
      initFormFields(["building-usage"]);
      autoSubmitOnSelect("building-usage");
      break;
    case "type":
      initFormFields(["type"]);
      autoSubmitOnSelect("type");
      break;
    case "address":
      initAddressAutocomplete();
      initFormFields(["#address"], false);
      break;
    case "size":
      initValidateLivingAreaAndOrBuildingVolume();
      initFormFields(["#plot-size", "#number-of-rooms"]);
      break;
    case "object":
      initFormFields(["standard", "condition", "construction-year"]);
      break;
    case "personal":
      validateMobile();
      initFormFields(["#first_name", "#last_name", "#email", "#evaluation_reason", "#privacy"]);
      break;
    case "verification":
      initStepVerification();
      break;
    case "result":
      initStepResult();
      initQuickNav();
      initHide();
      break;
  }

});
